import { Component, ContentChild, Input } from '@angular/core';
import { tabsStyles, TabsProps } from '@kite_aerolab/shared/components';
import { TabListComponent } from './tab-list.component';
import { TabPanelsComponent } from './tab-panels.component';

@Component({
  selector: 'kite-tabs',
  template: `
    <div [ngClass]="tabs">
      <ng-content></ng-content>
    </div>
  `,
})
export class TabsComponent {
  @ContentChild(TabListComponent) tabList: TabListComponent;
  @ContentChild(TabPanelsComponent) tabPanels: TabPanelsComponent;
  @Input() css: TabsProps['css'];
  activeIndex = 0;

  public get tabs(): string[] {
    return [tabsStyles({ css: this.css }).className];
  }

  ngAfterContentInit() {
    this.activeIndex = this.tabList.activeIndex;
    this.tabList.onTabChange.subscribe((index) => this.changeTab(index));
  }

  changeTab(index: number) {
    this.activeIndex = index;
    this.tabPanels.activeIndex = this.activeIndex;
  }
}
